const sections = [
    { name: "Fashion", image: "https://images.ctfassets.net/rxdl0mk5gigv/5nlnrhHWzVeujGGXPMffHo/50c574741a6d837e6463ebd02bd2601d/Screen_Shot_2022-08-08_at_12.09.07_PM.png" },
    { name: "Travel", image: "https://images.ctfassets.net/rxdl0mk5gigv/7kT6rt8rWmjiAIlgpul0MV/5e09033767284a82d25f6b5d6b90f4d2/IMG_2392.JPG" },
    { name: "Beyond the Lens", image: "https://images.ctfassets.net/rxdl0mk5gigv/6C5YtZR0bcnmVq8cFCZcB0/b8204e22767daa884dcb3de21c114bdd/sam-kolder.jpg" },
    { name: "Events", image: "https://images.ctfassets.net/rxdl0mk5gigv/2eFXQQ3vwAQgTymFPaZPuh/0a3077e5627977fa95ff951de08007a1/photo-output_6.JPG" },
    { name: "Motion Picture", image: "https://images.ctfassets.net/rxdl0mk5gigv/4JMctoNbnWFsIBZCSSNPvw/b7778ebcae32e7b0c64bf88e94df8db4/A-Snake-of-June.jpeg" },
    { name: "Photography", image: "https://images.ctfassets.net/rxdl0mk5gigv/6Yd2X42UScKKdaSvlKJfKm/a34ad9bd03e260cdd7dcb3eb2fae2c78/milla_jovovich_9_8.jpeg" },
  ]


const SectionList = () => (
<div className="sections flex flex-wrap justify-center content-center align-middle dt:mt-10 mb:mt-4 gap-2	">
        { sections.map(section => {
          return (
              <a
                className={`flex section-link w-[31%] text-center min-h-[200px] bg-black text-white`}
                key={section.name}
                href={`?tag=${section.name}`}
                style={{
                  backgroundImage: `url("${section.image}")`
                }}
              >
                <div className="self-center w-full">{section.name}</div>
              </a>
            )}
          )
        }
</div>)

export default SectionList;
